<template>
  <div class="login_main">
    <Particles class="Particles"></Particles>
    <div class="img_box">
      <el-image :src="require('@/assets/header_banner.jpg')"></el-image>
    </div>
    <div class="login_box">
      <el-image :src="require('@/assets/bg_logo.jpg')"></el-image>
      <el-card class="box_card">
        <div v-if="isShow">
          <el-tabs v-model="activeName" @tab-click="handleClick" >
            <el-tab-pane label="账号登录" name="0" >
              <el-form :model="loginForm" :rules="login_rules" ref="loginForm" style="margin-top:16px;">
                <el-form-item prop="username">
                  <el-input placeholder="账号/手机号/工号" v-model="loginForm.username">
                    <i slot="prefix" class="el-input__icon el-icon-user-solid" style="font-size:18px;"></i>
                  </el-input>
                </el-form-item>
                <el-row :gutter="15">
                  <el-col :span="15">
                    <div class="grid-content bg-purple">
                      <el-form-item prop="sms_code">
                        <el-input placeholder="短信验证码" v-model="loginForm.sms_code" >
                          <i slot="prefix" class="el-input__icon el-icon-chat-line-round" style="font-size:18px;"></i>
                        </el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="9">
                    <div class="grid-content bg-purple">
                      <el-button style="width:100%;" type="primary" 
                      :disabled="countFlag" @click="sendMobile()">
                      {{sms_tips == null ? countNum+'s重新发送' : sms_tips}}
                      </el-button>
                    </div>
                  </el-col>
                  </el-row>
                <el-form-item>
                  <el-button @click="onSubmit" style="width:100%;">登录</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="企业微信登录" name="1" >企业微信登录</el-tab-pane>
          </el-tabs> 
        </div>
        <div v-if="!isShow">
          <span>请关注微信公众号及时获取消息</span>
          <!-- <el-image :src="require('@/assets/bg_logo.jpg')"></el-image> -->
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import particlesJs from "../../components/particles/Particles.vue"
export default {
  data() {
    return {
      activeName: 0,
      isShow : true,
      sms_tips : '获取验证码',
      loginForm: {
        username: '',
        sms_code: '',
      },
      login_rules: {
        username: [
          { required: true, message: '请输入账号名', trigger: 'blur' },
        ],
        sms_code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ]
      },
      // 倒计时周期
      countNum:60,
      // 用于倒计时标记，true-正在倒计时
      countFlag:false,
      // 定时器
      intervalBtn:{},
    }
  },
  components:{
    Particles : particlesJs
  },
  methods:{
    onSubmit(){

    },
    handleClick(){

    },
    sendMobile(){
      // 设置btn倒计时时显示的信息
      this.sms_tips = null;
      // 更改btn状态
      this.countFlag =! this.countFlag;
      // 设置倒计时
      this.intervalBtn = setInterval(() => {
        if(this.countNum <= 0) {
          // 重置btn提示信息
          this.sms_tips = "获取验证码";
          // 清除定时器
          clearInterval(this.intervalBtn)
          // 更改btn状态
          this.countFlag =! this.countFlag;
          // 重置倒计时状态
          this.countNum = 5;
        };
        // 倒计时
        this.countNum -- ;
      }, 1000);
  },
  },
  created(){

  }
}
</script>
<style scoped lang="less">
.login_main{
  position: absolute;
  height: 120vh;
  width: 100vw;
  left: 0;
  top: 0;
}
.img_box{
  float: left;
  position :absolute;
  z-index: 999;
  left: 42vw;
  top: -22vh;
  width: 860px;
  // min-height: 290px;
}
.login_box{
  float: left;
  position :absolute;
  z-index: 999;
  left: 22vw;
  top: 18vh;
  width: 360px;
  min-height: 290px;
}
.box_card{
  min-height:290px;
  background-color: #fff;
}
</style>
